import directives from './directives';
import filters from './filters';
import models from './models';
import services from './services';
import translate from 'angular-translate';

/* global require */
if(!window.Intl) {
    require('intl');
    require('intl/locale-data/jsonp/nl-NL.js');
    require('intl/locale-data/jsonp/es-ES.js');
    require('intl/locale-data/jsonp/de-DE.js');
    require('intl/locale-data/jsonp/it-IT.js');
    require('intl/locale-data/jsonp/zh.js');
    require('intl/locale-data/jsonp/fr-FR.js');
    require('intl/locale-data/jsonp/en-GB.js');
}

import moment from 'moment';
import 'moment/locale/nl.js';
import 'moment/locale/nl-be.js';
import 'moment/locale/fr.js';
import 'moment/locale/es.js';
import 'moment/locale/it.js';
import 'moment/locale/de.js';
import 'moment/locale/zh-cn.js';
import 'moment/locale/en-gb.js';

/**
 * @ngdoc overview
 * @name eventix.common
 * @description
 * Common elements that are used throughout the application, such as Models, directives, filters
 */
export default angular.module('eventix.common', [
    directives,
    filters,
    translate,
    models,
    services
]).name;
